/**
 * 日历取数（R2，PLAN §6.1）
 * - 用 lunar-javascript 将本地时间转为农历（年、月、日、时辰），以农历为准
 * - 时辰规则：子=1（23:00–01:00，23:00 后按次日计）… 亥=12；lunar 库自动处理跨日
 * - 结果附带完整推演过程（UI 展示「正月 → [大安] → 初八 → […] → 午时 → [最终掌诀]」）
 */
import { Lunar } from 'lunar-javascript';
import { divinate, displayDay, displayHour, displayMonth } from './engine';
/**
 * 日历取数占卜（按设备本地时间）。
 * 取数规则：
 * - 时辰：子=1（23:00–01:00）… 亥=12（lunar 库 getTimeZhiIndex 提供）
 * - 跨日：PLAN §6.1「23:00 后按次日计」——本地时钟 23:00~23:59 的子时
 *   归属次日，农历月/日按公历次日推算（lunar 库默认按公历日界，需在此显式处理）
 * @param date 占卜时刻（默认现在）
 */
export function calendarDivination(date = new Date()) {
    const lunar = Lunar.fromDate(date);
    // 子时跨日：23:00 后，月/日取公历次日的农历值（时辰仍为子时=1）
    const crossing = date.getHours() >= 23;
    const refLunar = crossing ? Lunar.fromDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)) : lunar;
    const month = refLunar.getMonth();
    const day = refLunar.getDay();
    // getTimeZhiIndex()：0=子时 … 11=亥时
    const hour = lunar.getTimeZhiIndex() + 1;
    const ganZhiYear = refLunar.getYearInChinese();
    const lunarText = `农历${ganZhiYear}年${displayMonth(month)}${displayDay(day)}${displayHour(hour)}`;
    return {
        ganZhiYear,
        month,
        day,
        hour,
        lunarText,
        result: divinate(month, day, hour),
    };
}
//# sourceMappingURL=calendar.js.map